module.exports = __webpack_public_path__ + "img/自助签约@2x.0f122fa3.png";